import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {LfRoutes} from '@lightweightform/core';
import {UnionFormComponent} from './union-form/union-form.component';
import {UnionComponent} from './union.component';


const routes: LfRoutes = [
  {
    path: '',
    component: UnionComponent,
    children: [
      {path: '', redirectTo: 'union-form', pathMatch: 'full'},
      {path: 'union-form', component: UnionFormComponent},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
